export const valueToList = (value: string | string[]) => {
  // TODO: write tests for this function
  if (value instanceof Array) {
    return value;
  }
  if (!value) {
    return [];
  }
  return value.startsWith('[')
    ? JSON.parse(value).map(String)
    : [value.toString()];
};
